import { render, staticRenderFns } from "./TreatmentAreaByBrand.vue?vue&type=template&id=590a2334&"
import script from "./TreatmentAreaByBrand.vue?vue&type=script&lang=js&"
export * from "./TreatmentAreaByBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports